import React from "react";
import Trash from "assets/images/trash.png";

export const AccountDeletionConfirmModalBody = ({ onDelete, handleBack }) => {
  return (
    <div className="Account_deletion">
      <div className="deletion_image">
        <img src={Trash} alt="" />
      </div>
      <div className="content_deletion p-4">
        <p className="delete-confirm-text">
          You want to delete your account Permanently.
        </p>
        <div className="modal-action m-0">
          <div className="modal-action btn_password m-0">
            <div className="button-group d-flex justify-content-center gap-3">
              <button
                className="btn cstm-btn-outline-close px-4"
                onClick={handleBack}
              >
                Close
              </button>

              <button
                className="btn btn-primary px-4"
                onClick={onDelete}
              >
                Delete
              </button>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};
